function handleNav() {
    // Footer height based on nav height
    $('.icg-nav ul').on('shown.bs.collapse', function() {
        var height = $('.icg-nav').outerHeight();
        $('body').css('min-height', height);
    });
    $('.icg-nav ul').on('hidden.bs.collapse', function() {
        $('body').removeAttr('style').delay(250);
        var nheight = $('.icg-nav').outerHeight();
        $('body').css('min-height', nheight);
    });

    // Select Active Page in Menu
    var currentPath = window.location.pathname;
    $('.icg-nav')
        .find('.nav-item > a[href="' + currentPath + '"]')
        .parent().addClass('active')
        .parent().addClass('show')
        .siblings().attr('aria-expanded','true')
        .parent().addClass('active');
  
    // Toggle left nav menu and set state in localStorage
    $('.nav-toggle').on('click', function(e) {
        var windowWidth = $(window).outerWidth();
        if(windowWidth < 992) {
            $('.icg-nav').toggleClass('icg-nav-expand');
            localStorage.setItem('menu-tablet-collapsed', $('.icg-nav').hasClass('icg-nav-expand'));
        } else {
            $('.icg-nav').toggleClass('icg-nav-collapse');
            localStorage.setItem('menu-desktop-collapsed', $('.icg-nav').hasClass('icg-nav-collapse'));
        }
    });
    $('.icg-nav-dimmer').on('click', function() {
        $('.icg-nav').toggleClass('icg-nav-expand');
    });
    
    // Read left nav menu state from localStorage
    var tabletState = localStorage.getItem('menu-tablet-collapsed');
    var desktopState = localStorage.getItem('menu-desktop-collapsed');

    // Close left nav menu (tablet) when localStorage is not set
    if (tabletState === null) {
        $('.icg-nav').removeClass('icg-nav-expand');
    } else {
        var tabletClassState = tabletState === "true" ? true : false;

        if (!tabletClassState) {
            $('.icg-nav').removeClass('icg-nav-expand');
        } else {
            $('.icg-nav').addClass('icg-nav-expand');
        }
    }

    // Open left nav menu (desktop) when localStorage is not set
    if (desktopState === null) {
        $('.icg-nav').removeClass('icg-nav-collapse');
    } else {
        // Save left nav menu state to variable when localStorage is set
        // Set to a boolean true/false value instead of a string "true" or "false"      	
        var desktopClassState = desktopState === "true" ? true : false;

        // When the state of the menu is not closed, remove the collapsed class from the sidebar.
        if (!desktopClassState) {
            $('.icg-nav').removeClass('icg-nav-collapse');
        } else {
            $('.icg-nav').addClass('icg-nav-collapse');
        }
    }
}

function handleDatePickers(selector){
    $(selector).each(function () {
        $(this).datepicker({
            uiLibrary: 'bootstrap4',
            showOnFocus: true,
            iconsLibrary: 'fontawesome',
            format: 'yyyy-mm-dd',
            icons: {
                rightIcon: '<i class="far fa-calendar-alt"></i>'
            }
        });
    });
}

function handleSimpleDataTable(selector){
    $(selector).DataTable({ responsive: true});
}

function handleSimpleDataTableWithState(selector){
    $(selector).DataTable({ responsive: true, stateSave: true });
}

function handleFilePickers(selector){
	$(selector).on('change', function () {
            //get the file name
            var fileName = $(this).val();
            //replace the "Choose fileâ€¦" label
            $(this).next('.custom-file-label').html(fileName);
        });
}
/* Custom Download Tracking */
function setCookie (name, value, expiracy) {
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiracy * 1000);
    var c_value = escape(value) + ((expiracy == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value + '; path=/';
}

function getCookie (name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == name) {
            return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y; //;//unescape(decodeURI(y));
        }
    }
}

function handleDownloadDialog(selector){
    $(selector).click(function () {
        processingOverlay.show();
        setCookie('downloadStarted', 0, 100); //Expiration could be anything... As long as we reset the value
        setTimeout(checkDownloadCookie, 1000); //Initiate the loop to check the cookie.
    });
}


var downloadTimeout;
function checkDownloadCookie () {
    if (getCookie("downloadStarted") == 1) {
        setCookie("downloadStarted", "false", 100); //Expiration could be anything... As long as we reset the value
        processingOverlay.hide();
    } else {
        downloadTimeout = setTimeout(checkDownloadCookie, 1000); //Re-run this function in 1 second.
    }
}

// source: https://stackoverflow.com/questions/18999501/bootstrap-3-keep-selected-tab-on-page-refresh/42591519#42591519
/// put on a page to save tab navigation through page redirects
/// pagekey is the key this info will be saved to in localStorage
function saveTabNavigation(pagekey) {
    $(function () {
        var activeTab = localStorage.getItem(pagekey);
        if (activeTab && $('a[href="' + activeTab + '"]').length) {
            $('a[href="' + activeTab + '"]').tab('show');
        }
        else if (location.hash && $('a[href=\'' + location.hash + '\']').length) {
            $('a[href=\'' + location.hash + '\']').tab('show');
        }
        else {
            var firstTab = $('.nav-tabs a:first').attr("href");

            location.hash = firstTab;

            localStorage.setItem(pagekey, firstTab);
            $('a[href="' + firstTab + '"]').tab('show');
        }
    });

    $('body').on('click', 'a[data-toggle=\'tab\']', function (e) {
        e.preventDefault();
        var tab_name = this.getAttribute('href');
        if (history.pushState) {
            history.pushState(null, null, tab_name);
        }
        else {
            location.hash = tab_name;
        }
        localStorage.setItem(pagekey, tab_name);

        $(this).tab('show');
        return false;
    });

    $(window).on('popstate', function () {
        var anchor = location.hash || $('a[data-toggle=\'tab\']').first().attr('href');
        $('a[href=\'' + anchor + '\']').tab('show');
    });
}

/// run when a tab nav should be reset
function resetTabNavigation(pagekey) {
    localStorage.setItem(pagekey, undefined);
}

// expected props structure:
//  tableKey -> required: id of the table this function will handle.
//  actionColumn -> optional: column settings for action column to be appended
//  onFilterSearch -> optional: function that will be ran when filter button is pushed. for UI data dependant on filter inputs. use jquery drawCallback object for things requiring query data.
//  filterSettings -> optional: array of info on each filter input.
//           filterKey -> required: id of the filter this will handle
//           inputType -> optional: select or input. if single or multi select, use select. everything else is input. defaults to input.
//           defaultDataLoad -> optional: function that will be ran after data is loaded.
//  dataLoad -> optional function ran to load data for ajax.data
//  jquerySettings -> required: spreads all contained objects directly into jquery datatable setup.
//           columns -> required
//  ajaxSettings -> optional: spreads all contained objects directly into ajax setup.
//  columnOverrides -> optional: list used to override columns defaults.
//           target     -> required: column index these settings apply to
//           data       -> optional: column setting to override
//           title      -> optional: column setting to override
//           visible    -> optional: column setting to override
//           searchable -> optional: column setting to override
//           render     -> optional: column setting to override

//  Returns the query function to be ran on filter button push.
function handleJqueryDataTable(props) {
    if (!props.tableKey) {
        throw "tableKey is required";
    }

    if (!props.jquerySettings) {
        throw "jquerySettings is required";
    } else if (!props.jquerySettings.columns) {
        throw "jquerySettings columns is required";
    }

    var tableId = "#" + props.tableKey;

    $(document)
        .ready(function () {
            if (props.filterSettings && props.filterSettings.length > 0) {
                for (var i = 0; i < props.filterSettings.length; i++) {
                    var filterSetting = props.filterSettings[i];

                    if (!filterSetting.filterKey) {
                        throw "a filter setting is missing a filterkey";
                    }

                    if (filterSetting.inputType === "select") {
                        LoadSelect(filterSetting.filterKey);
                    } else {
                        LoadInput(filterSetting.filterKey);
                    }

                    $('#' + filterSetting.filterKey).change(SaveInput(filterSetting.filterKey));
                    if (filterSetting.defaultDataLoad) {
                        filterSetting.defaultDataLoad();
                    }
                }
            }

            for (var j = 0; j < props.jquerySettings.columns.length; j++) {
                var p = lowerFirstLetter(props.jquerySettings.columns[j].data);
                props.jquerySettings.columns[j].render = createRender(p);

                if (props.columnOverrides) {
                    var overrideFilter = props.columnOverrides.filter(filterFunc(j));

                    if (overrideFilter.length > 0) {
                        var override = overrideFilter[0];
                        if (override.data) {
                            props.jquerySettings.columns[j].data = override.data;
                        }

                        if (override.title) {
                            props.jquerySettings.columns[j].title = override.title;
                        }

                        if (override.visible) {
                            props.jquerySettings.columns[j].visible = override.visible;
                        }

                        if (override.searchable) {
                            props.jquerySettings.columns[j].searchable = override.searchable;
                        }

                        if (override.render) {
                            props.jquerySettings.columns[j].render = override.render;
                        }

                        if (override.orderable) {
                            props.jquerySettings.columns[j].orderable = override.orderable;
                        }
                    }
                }
            }

            if (props.actionColumn) {
                props.jquerySettings.columns.push(props.actionColumn);
            }

            Query();


            function createRender(p) {
                return function (data, type, row) { return row[p]; };
            }

            function lowerFirstLetter(str) {
                return str.charAt(0).toLowerCase() + str.slice(1);
            }

            function filterFunc(index) {
                return function (element) {
                    return element.target === index;
                };
            }
        });

    $.fn.dataTable.render.moment = function (to, locale) {
        return function (d, type, row) {
            if (!d) {
                return type === 'sort' || type === 'type' ? 0 : d;
            }
            var m = window.moment.utc(d);

            // Order and type get a number value from Moment, everything else
            // sees the rendered value
            return m.local().format(type === 'sort' || type === 'type' ? 'x' : to);
        };
    };

    function Query() {
        if ($.fn.dataTable.isDataTable(tableId)) {
            $(tableId).DataTable().destroy();
            $(tableId).empty();
        }

        if (props.onFilterSearch) {
            props.onFilterSearch();
        }

        $(tableId)
            .DataTable(Object.assign(
                {},
                {
                    serverSide: true,
                    stateSave: true,
                    responsive: true,
                    ajax: getAjaxObject(),
                    columnDefs: [{
                        "defaultContent": "",
                        "targets": "_all"
                      }]
                },
                props.jquerySettings)
            );

        function getAjaxObject() {
            var obj = { type: "POST" };

            if (props.dataLoad) {
                obj.data = props.dataLoad();
            }

            if (props.ajaxSettings) {
                obj = Object.assign(
                    {},
                    obj,
                    props.ajaxSettings);
            }

            return obj;
        }
    }

    function SaveInput(key) {
        return function () {
            var value = $('#' + key).val();
            sessionStorage.setItem(props.tableKey + key, value);
        };
    }

    function LoadInput(key) {
        var data = sessionStorage.getItem(props.tableKey + key);
        if (data && data.length) {
            $('#' + key).val(data);
        }
    }

    function LoadSelect(key) {
        var data = sessionStorage.getItem(props.tableKey + key);
        if (data && data.length) {
            var dataList = data.split(',');
            $('#' + key).val(dataList).change();
        }
    }

    return Query;
}

// takes a number and amount to pad it by. (9,5) -> 00009. (999,5) -> 00999
var zeroPad = function (num, places) { return String(num).padStart(places, '0'); };

// helper methods for formatting dates. 
// GetDateFormatted -> takes a date and returns YYY-MM-DD format. No data returns null
// GetDateFormattedHtml -> takes a date and returns m/d/yyyy format. No data returns minus icon
// GetRelativeDateFormattedHtml -> takes a date and returns relative data tag. No data returns minus icon
var dateHelper = {
    GetDateFormatted: function (data) {
        if (data) {
            if (data.length <= 10) {
                data = (data + '').replace(/-/g, '/'); // if time not included. dont adjust for timezone.
            }
            var date = new Date(data);
            var month = date.getMonth() + 1;
            var dateformatted = date.getFullYear() + '-' + zeroPad(month, 2) + '-' + zeroPad(date.getDate(), 2);
            return dateformatted;
        } else {
            return null;
        }
    },
    GetDateFormattedHtml: function (data) {
        if (data) {
            if (data.length <= 10) {
                data = (data + '').replace(/-/g, '/'); // if time not included. dont adjust for timezone.
            }
            var date = new Date(data);
            var month = date.getMonth() + 1;
            var dateformatted = month + '/' + date.getDate() + '/' + date.getFullYear();

            return '<span>' + dateformatted + '</span>';
        } else {
            return '<i class="fas fa-minus"></i>';
        }
    },
    GetRelativeDateFormattedHtml: function (data) {
        if (data) {
            if (data.length <= 10) {
                data = (data + '').replace(/-/g, '/'); // if time not included. dont adjust for timezone.
            }
            var date = new Date(data);
            var month = date.getMonth() + 1;
            var dateformatted = month + '/' + date.getDate() + '/' + date.getFullYear();

            return '<relative-time datetime="' + dateformatted + ' UTC"></relative-time>';
        } else {
            return '<i class="fas fa-minus"></i>';
        }
    }
};

// the modal used in `handleDeleteModalSetup()`
var deleteConfirmModal = 
'<div id="deleteConfirm-modal" class="modal modal-danger fade" role="dialog">'+
    '<div class="modal-dialog modal-dialog-centered" role="document">'+
        '<div class="modal-content">'+
            '<div class="modal-header">'+
                '<h5 class="modal-title">Confirm Delete</h5>'+
                '<button type="button" class="close" data-dismiss="modal" aria-label="Close">'+
                    '<span aria-hidden="true">&times;</span>'+
                '</button>'+
            '</div>'+
     
            '<div class="modal-body">'+
                '<p id="deleteConfirmMessage"></p>'+
            '</div>'+
     
            '<div class="modal-footer">'+
                '<form id="deleteForm" class="form-inline" role="form">'+                    
                    '<button type="button" class="btn btn-outline-dark mr-1" data-dismiss="modal"> Cancel</button>'+
                    '<button type="submit" class="btn btn-danger"><i class="fas fa-trash"></i> Delete</button>'+                     
                '</form>'+
            '</div>'+
        '</div>'+
    '</div>'+
'</div>';


// modalContainerId - the modal container to load the delete modal into
// additionalMessages - (optional) additional messages to choose from. (object list that replaces delete message text)
// data-<attr> - On the delete button, need to add these data binding settings:
//    * messagetype - (optional) can use an option setup by `additionalMessages` otherwise uses a default message
//    * actionurl - The endpoint the delete action hits if confirmed
//    * deleteid - The id of the object to delete
//    * updateid - The id of the element that will be refreshed with data returned by `actionurl`
function handleDeleteModalSetup(modalContainerId, additionalMessages){
    var deleteMessages = {
        default: 'Are you sure you want to delete this?'
    };

    if (additionalMessages) {
        deleteMessages = Object.assign(
            {},
            deleteMessages,
            additionalMessages);
    }

    $('#' + modalContainerId).html(deleteConfirmModal);

    $('#deleteConfirm-modal').on('show.bs.modal',
        function (event) {
            var button = $(event.relatedTarget);
            var messageType = button.data('messagetype');
            var deleteAction = button.data('actionurl');
            var deleteId = button.data('deleteid');
            var updateId = button.data('updateid');
            var func = button.data('successfunction');

            var deleteMessage = deleteMessages[messageType] ?  deleteMessages[messageType] : deleteMessages['default'];

            var modal = $(this);
            modal.find('#deleteConfirmMessage').text(deleteMessage);

            var form = modal.find('#deleteForm');
            form.off('submit');
            form.on('submit', function (e) { 
                e.preventDefault();
                deleteWithAjax(deleteAction, deleteId, updateId, func); 
            });
        }
    ); 

    function deleteWithAjax(action, deleteId, updateId, successFunc) {		
        $.ajax({
            type: "POST",
            url: action,
            data:{
                id: deleteId
            },
            beforeSend: function (request) {
                request.setRequestHeader("RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
            },
            success: function(data)
            {
                $('#deleteConfirm-modal').modal('hide');
		
				        if(updateId){
					        $('#' + updateId).html(data);
				        }   

				        if(successFunc){
					        window[successFunc]();
				        }				
            },
            error: function (xhr, status) {
                alert("Sorry, there was a problem!");
            }
        });
    }
}

// modalContainerId - the modal container to load the partial into
// urlAction - the endpoint to get the partial from
// dataObject - any data that needs to be given to the endpoint
function loadModalWithAjax(modalContainerId, urlAction, dataObject){
    $.ajax({
        cache: false,
        type: "GET",
        url: urlAction,
        data: dataObject,
        beforeSend: function (request) {
            request.setRequestHeader("RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
        },
        success: function (data) {
            $('#' + modalContainerId).html(data);

            $('#' + modalContainerId).find('.modal').modal('show');
        },
        error: function (xhr, status) {
            alert("Sorry, there was a problem!");
        }
    });
}

// formId - the form to serialize the data for.
// modalId - the modal to hide
// updateId - the element containing only the partial that should be updated.
// addedSerializedData - (optional) data added to the end of the serialized form.
// additionalSuccessFunction - (optional) a function that will be ran after update element is replaced with a new partial.
function saveForm(formId, modalId, updateId, addedSerializedData, additionalSuccessFunction) {
    var form = $('#' + formId);
    if (!form.valid()) {
        return;
    }
     
    $.ajax({
        type: "POST",
        url: form.attr('action'),
        data: form.serialize() + (addedSerializedData ? addedSerializedData : ''),
        beforeSend: function (request) {
            request.setRequestHeader("RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
        },
        success: function (data) {
            $('#' + modalId).modal('hide');
            $('#' + updateId).html(data);
            if (additionalSuccessFunction) {
                additionalSuccessFunction();
            }
        }
    });
}

function sfGridLoad() {

    if (ej.base.Browser.isDevice) {
        // Render Adaptive Grid
        this.enableAdaptiveUI = true;
        this.rowRenderingMode = 'Vertical';

    } else {
        // Render normal Grid
        var parentEle = this.element.closest('.e-bigger');
        if (parentEle) {
            parentEle.classList.remove('e-bigger');
        }

        this.enableAdaptiveUI = false;
        this.rowRenderingMode = undefined;
    }
}